export default {"src":"/_next/static/media/x.9f8c9710.svg","height":15,"width":15};